import { EventEmitter } from 'events';

import dispatcher from '../others/Dispatcher';
import * as DH from '../others/DataHelpers';

class AssignmentStore extends EventEmitter {
    constructor() {
        super()
        this.columns = [
            {
                id: 'type',
                label: 'type'
            }, {
                id: 'number',
                label: 'number'
            }, {
                id: 'status',
                label: '',
            }
        ]
        this.tickets = [];
        this.ticketsDisplay = [];
        this.sort = {
            assignmentSort: 'ticketLength',
            order: 'desc',
            orderBy: 'priority',
            secondaryOrder: 'desc',
            secondaryOrderBy: 'number',
        };
        this.meta = {
            loading: true,
            refresh: false,
        };
        this.github = {
            filter: {
                labels: 'customer,defect'
            },
            user: 'MindTouch',
            repo: 'Deki',
        }

        this.userList = [
            'apatten',
            'derekrobbins',
            'dobberteen',
            'spencerkittleson',
            'Ailuridaes',
            'bmherron',
            'franciscoCrespo0101',
            'modethirteen',
            'acre8tivemynd',
            'pattyr',
            'taustgen',
            'onema',
            'PeteE',
            'trypton',
            'aaronmars',
            'djmlee013',
        ];
        this.assigneeTickets = [];
        this.assigneeTicketsDisplay = [];

    }

    getAll() {
        const { columns, tickets, ticketsDisplay, filter, gitFilter, sort, meta } = this;
        return {
            columns,
            tickets,
            ticketsDisplay,
            filter,
            gitFilter,
            sort,
            meta,
        }
    }

    updateTickets = () => {
        const params = {
            filter: this.github.filter,
            user: this.github.user,
            repo: this.github.repo,
            userList: this.userList,
        }
        DH.getAssignments(params)
            .then((tickets) => {
                this.tickets = tickets;
                this.ticketsDisplay = this.tickets
                    .sort(DH.getSorting(this.sort));
                this.meta.loading = false;
                this.emit('change');
            })
    }


    updateFilter = (filter) => {
        this.ticketsDisplay = this.tickets
            .filter(DH.getStatusFiltering(filter))
            .filter(DH.getAssignmentFiltering(filter))
            .filter(DH.getReleaseFiltering(filter))
            .filter(DH.getSeverityFiltering(filter))
            .sort(DH.getSorting(this.sort))
        this.filter = filter;
        this.meta.loading = false;
        this.emit('change');
    }

    updateSort = (sortEvent) => {
        if(this.sort.orderBy === sortEvent.property) {
            this.sort.order = (this.sort.order === 'asc') 
                ? 'desc' 
                : 'asc';
        } else {
            this.sort.order = 'desc';
        }
        this.sort.orderBy = sortEvent.property;

        const newTicketsDisplay = this.ticketsDisplay
            .sort(DH.getSorting(this.sort));
        this.ticketsDisplay = newTicketsDisplay;
        this.meta.loading = false;
        this.emit('change');
    }


    updateMeta = (meta) => {
        this.meta = meta;
        this.emit('change');
    }
    updateAuthentication = (authentication) => {
        this.meta.authentication = authentication;
        this.emit('change');
    }

    handleActions = (action) => {
        switch(action.type) {
            case 'UPDATE_ASSIGN_TICKETS':
                this.updateTickets(action.body);
                break;
            case 'UPDATE_ASSIGN_TICKETS_DISPLAY':
                this.updateTicketsDisplay(action.body);
                break;
            case 'UPDATE_ASSIGN_FILTER':
                this.updateFilter(action.body);
                break;
            case 'UPDATE_ASSIGN_SORT':
                this.updateSort(action.body);
                break;
            case 'UPDATE_ASSIGN_META':
                this.updateMeta(action.body);
                break;
            case 'REFRESH':
                this.updateTickets(action.body);
                break;
            case 'UPDATE_AUTHENTICATION':
                this.updateAuthentication(action.body);
                break;
            default:
        }
    }
}

const assignmentStore = new AssignmentStore();
dispatcher.register(assignmentStore.handleActions.bind(assignmentStore));
window.assignmentStore = assignmentStore;
export default assignmentStore;


// WEBPACK FOOTER //
// ./src/js/stores/AssignmentStore.js